import React, { useState, useContext } from 'react';
import Navigation from '@safetywing-tech/global-navbar';
import { useSelector, useDispatch } from 'react-redux';
import usePageType from 'hooks/usePageType';
import NINavigation from 'products/nomad_insurance/components/Navigation';
import ParallaxContext from 'components/ParallaxWrapperFiber/context';
import { Link } from 'components/Typography';
import { logOutUser } from 'state/app';
import AvatarIcon from './AvatarIcon';

const GlobalNavigation = () => {
  const dispatch = useDispatch();
  const pageType = usePageType();
  const { isNomadInsurance, isClaims } = pageType;
  const { user, isInitInProgress } = useSelector((state) => state.app);
  const [isProductNavOpen, setIsProductNavOpen] = useState(false);
  const mainSiteUrl = window.location.origin;
  const { childrenRef: parallaxChildrenRef } = useContext(ParallaxContext);

  if (isClaims) {
    return null;
  }

  return (
    <Navigation
      isMainSite
      showLogin
      mainSiteUrl={mainSiteUrl}
      pageType={pageType}
      isProductNavOpen={isProductNavOpen}
      user={user}
      logOutUser={() => dispatch(logOutUser())}
      isInitInProgress={isInitInProgress}
      parallaxChildrenRef={parallaxChildrenRef}
      avatarElement={
        user?.avatar ? (
          <AvatarIcon
            avatar={user?.avatar}
            gender={user?.gender}
            firstName={user?.firstName}
            lastName={user?.lastName}
          />
        ) : null
      }
      linkComponent={Link}
    >
      {isNomadInsurance && <NINavigation isProductNavOpen={setIsProductNavOpen} />}
    </Navigation>
  );
};

export default GlobalNavigation;
